import { client } from './setup';
import { SETTINGS_API } from '../globals';

export default {
    getSettings: () => client.get(SETTINGS_API),
}